import api from "./api";

export interface LoginRequest {
  email: string;
  password: string;
}

export interface RegisterRequest {
  name: string;
  email: string;
  password: string;
  phone: string;
  roleID: string;
  organizationID: string;
  know_from:string;
  court_id:string;
}

export interface UpdateRequest {
  name: string;
  email: string;
  phone: string;
  roleID: string;
  organizationID: string;
  password: string;
}

export interface AuthResponse {
  message: string;
  success: string;
  status: string;
  token: string;
  refreshToken: string;
  user: {
    id: string;
    name: string;
    email: string;
    phone: string;
    created_at : string;
  };
}

export interface UpdateUserResponse {
  success: string;
  status: string;
  message: string;
}

export interface RefreshTokenResponse {
  token: string;
  refreshToken: string;
}

export const authService = {
  // Login user
  async login(credentials: LoginRequest): Promise<AuthResponse> {
    try {
      const response = await api.post<AuthResponse>("/auth/login", credentials);
      console.log("THIS IS THE RESPONSE:", response.data);
      return response.data;
    } catch (error: any) {
      if (error.response) {
        // Log and return the error payload from server
        console.error("LOGIN ERROR:", error.response.data);
        return error.response.data;
      } else {
        console.error("LOGIN UNKNOWN ERROR:", error.message);
        throw error;
      }
    }
  },

  // Register user
  async register(userData: RegisterRequest): Promise<AuthResponse> {
    // const response = await api.post<AuthResponse>('/auth/register', userData);
    try {
      const response = await api.post<AuthResponse>("/users/", userData);
      console.log("THIS IS THE RESPONSE:", response.data);
      return response.data;
    } catch (error: any) {
      if (error.response) {
        // Log and return the error payload from server
        console.error("REGISTER ERROR:", error.response.data);
        return error.response.data;
      } else {
        console.error("REGISTER UNKNOWN ERROR:", error.message);
        throw error;
      }
    }
  },

  // Refresh token
  async refreshToken(refreshToken: string): Promise<RefreshTokenResponse> {
    const response = await api.post<RefreshTokenResponse>("/auth/reCreate", {
      refreshToken,
    });
    return response.data;
  },

  // Logout user
  async logout(): Promise<void> {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        await api.post("/auth/logout");
      } catch (error) {
        // Even if logout API fails, we still clear local storage
        console.error("Logout API call failed:", error);
      }
    }

    // Always clear local storage
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("user");
  },

  // Get current user profile
  async getProfile(): Promise<AuthResponse["user"]> {
    const response = await api.get<AuthResponse["user"]>("/auth/profile");
    return response.data;
  },

  // Update current user profile
  async updateProfile(userData: UpdateRequest): Promise<UpdateUserResponse> {
    const user_id = JSON.parse(localStorage.getItem("user"))?.id;
    try {
      const response = await api.put<UpdateUserResponse>(
        `/users/${user_id}`,
        userData
      );
      return response.data;
    } catch (error: any) {
      if (error.response) {
        return error.response.data;
      } else {
        throw error;
      }
    }
  },
};
